import { ITagAssociationType } from "../../common/models/ITagAssociationType";
import restService from "../rest-service/RestService";
import { IGroupMarketingReport, IGroupMarketingReportExportOptions, IGroupMarketingReportQueryParams } from "./Models";

const GroupMarketingReportDataService = {

    getGroupMarketingReport: async function(
        groupID: number,
        startDate: Date,
        tagAssociationTypeId: number | undefined,
        abortSignal?: AbortSignal
    ): Promise<IGroupMarketingReport> {

        var queryParams: IGroupMarketingReportQueryParams = {          
            startDate: startDate,
            tagAssociationTypeId: tagAssociationTypeId
        };

        //"groups/{groupID:int}/marketingreport"

        const path: string= [
            "groups",
            groupID,
            "marketingreport"
        ].join("/");

        const response = await restService.get<IGroupMarketingReport, IGroupMarketingReportQueryParams>(
            path,
            abortSignal,
            queryParams
        );

        return response.data;

    },

    exportGroupMarketingReport: async function(
        groupID: number, 
        options: IGroupMarketingReportExportOptions

    ): Promise<void> {

      //  path = groups/[groupId]/marketingreport/export
       const path: string = [
           "groups",
           groupID,
           "marketingreport",
           "export"
       ].join("/");

       await restService.post(path, options);

    },
    getGroupMarketingReportTats: async function(
        groupID: number,
        abortSignal?: AbortSignal
    ): Promise<ITagAssociationType[]> {

        const path = `groups/${groupID}/marketingreport/tats`;

        const response = await restService.get<ITagAssociationType[], IGroupMarketingReportQueryParams>(
            path,
            abortSignal
        );

        return response.data;

    },
};

export default GroupMarketingReportDataService;



//    // Group Marketing Report
//    public exportGroupMarketingReport(notificationKey: string, mimeType: Enums.ApplicationMimeTypesEnum, groupId: number, month: number, year: number, tagAssociationTypeId: number): Services.RestPromise<any> {

//        // path = groups/[groupId]/marketingreport/export
//        const path: string = [
//            "groups",
//            groupId,
//            "marketingreport",
//            "export"
//        ].join("/");

//        const params: Models.IGroupMarketingReportExportOptions = {
//            notificationKey: notificationKey,
//            mimeType: mimeType,
//            startDate: this._createMoment(year, month),
//            tagAssociationTypeId: tagAssociationTypeId
//        };

//        return this._restService.post(path, params).then((data) => {
//            return data.entity;
//        });
//    }

//    public getGroupMarketingReport(groupId: number, month: number, year: number, tagAssociationTypeId: number): Services.RestPromise<Models.IGroupMarketingReport> {

//        // path = groups/[groupId]/marketingreport
//        const path: string = [
//            "groups",
//            groupId,
//            "marketingreport"
//        ].join("/");

//        const params: Models.IGetGroupMarketingReportQueryParams = {
//            startDate: this._createMoment(year, month),
//            tagAssociationTypeId: tagAssociationTypeId
//        };

//        return this._restService
//            .get<Models.IGroupMarketingReport, Models.IGetGroupMarketingReportQueryParams>(path, params)
//            .then((data) => {

//                return data.entity;

//            });

//    }

//    public getGroupMarketingReportTats(groupId: number): Services.RestPromise<Array<Models.ITagAssociationType>> {

//        // path = groups/[groupId]/marketingreport
//        const path: string = [
//            "groups",
//            groupId,
//            "marketingreporttats"
//        ].join("/");

//        //const params: Models.IGetGroupMarketingReportQueryParams = {
//        //    startDate: this._createMoment(year, month),
//        //    tagAssociationTypeId: tagAssociationTypeId
//        //};

//        return this._restService
//            .get<Array<Models.ITagAssociationType>>(path)
//            .then((data) => {

//                return data.entity;

//            });

//    }

//    private _createMoment(year: number, month: number): moment.Moment {

//        return moment(new Date(year, month, 1, 0, 0, 0, 0));

//    }

//}